import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { WishlistModel } from "@/redux/modules/api/data/wishlist/@types/wishlist.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type WishlistListItemProps = {
    list: WishlistModel;
    isSelected: boolean;
    onSelect: (id: string) => void;
};

const WishlistListItem = ({
    list,
    isSelected,
    onSelect
}: WishlistListItemProps) => {
    const { t } = useGranite();

    const itemCount = list.products.length;

    return (
        <Button
            color={isSelected ? "primary" : "link"}
            className={cn(
                "tw:flex tw:items-center tw:justify-between tw:py-1 tw:px-2 tw:rounded-none!"
            )}
            onClick={() => onSelect(list.id)}
        >
            <span className={"tw:block"}>
                {list.name || t("wishlist.wishlistName")}
            </span>
            <span
                className={cn(
                    "tw:block tw:text-sm tw:font-light tw:m-0 tw:pt-1"
                )}
            >
                {t(
                    `wishlist.item.itemcount.${
                        itemCount === 0
                            ? "none"
                            : itemCount > 1
                              ? "multiple"
                              : "single"
                    }`,
                    itemCount
                )}
            </span>
        </Button>
    );
};

export { WishlistListItem };
